import { config } from '../config';

export async function callGetJson(endPoint) {
  let headers = new Headers();
  var url = new URL(`${config.url.JSON_CONF_URL}/${endPoint}`);
  const response = await fetch(url, {
    method:'GET',
    headers: headers,
    cache: 'no-cache'
  });
  return response.json();
}
